import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthrizedAppointmentBooking from "../pages/appointmentBooking/authrizedAppointmentBooking";
import UnauthrizedAppointmentBooking from "../pages/appointmentBooking/unauthrizedAppointmentBooking";
import AppointmentBooking from "../pages/appointmentBooking/appointmentBooking";
import Dashboard from "../pages/dashboard/Dashboard";
import { GuestBoard } from "../pages/guestboard/guestBoard";
import Login from "../pages/login/Login";
import PickUpAndDropFeedbackForm from "../pages/pickUpAndDropFeedbackForm/pickUpAndDropFeedbackForm";
import { WelcomeBoard } from "../pages/welcomeboard/welcomeBoard";
import { WorkShopBoard } from "../pages/workShopBoard/workshopBoard";
import PrivateOutlet from "./PrivateRoute";
import InstantFeedbackForm from "../pages/pickUpAndDropFeedbackForm/instantFeedbackForm";
import JobCardStatus from "../pages/dashboard/JobCardStatus";
import { useEffect, useState } from "react";
// import PrivateOutlet from "./PrivateRoute";
import {socketIO} from '../socket'

const RouteComponent = () => {
  const socketData=socketIO.connect()

  console.log(socketData,'socketData')
	return (
    <BrowserRouter>
      <Routes>
        {/* Authentication */}
      {window.location.pathname==='/appointmentBooking'?
      <Route path="/appointmentBooking" element={<AuthrizedAppointmentBooking />}></Route>:
      <Route path="/login" element={<Login />}></Route>
    }
     
        <Route path="/" element={<Login />}></Route>
        <Route path="/RO/:docId" element={<JobCardStatus />}></Route>
        {/* <Route path="/authrizedAppointmentBooking" element={<AuthrizedAppointmentBooking/>}></Route> */}
        <Route path="/unauthrizedAppointmentBooking" element={<UnauthrizedAppointmentBooking/>}></Route>
          
        <Route path="/" element={<PrivateOutlet />}>
          <Route path="/dashboard" element={<Dashboard />}></Route>
          <Route path="/dashboard/guestboard" element={<GuestBoard socket={socketData}/>}></Route>
          <Route path="/dashboard/welcomeboard" element={<WelcomeBoard socket={socketData}/>}></Route>
          <Route path="/dashboard/workshopboard" element={<WorkShopBoard socket={socketData} />}></Route>
          {/* <Route path="/appointmentBooking" element={<AppointmentBooking />}></Route> */}
        <Route path="/pickupAndDropFeedbackForm/:id" element={<PickUpAndDropFeedbackForm />}></Route>
          <Route path="/instantFeedbackForm/:id" element={<InstantFeedbackForm />}></Route>

          {/* Wild Card entry */}
          <Route path="*" element={<div> Page Not found</div>}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default RouteComponent;
